import type { App as VueApp } from '@vue/runtime-core';
import { createInertiaApp } from '@inertiajs/vue3';
import { ZiggyVue as Ziggy } from 'ziggy-js';
import initSentry from '@/App/Sentry.js';
import { Ziggy as ziggyOptions } from '@/Ziggy/Routes.js';

createInertiaApp({
    pages: './AppPages',
    withApp(app: VueApp, { ssr }) {
        initSentry(app);
        app.use(Ziggy, getZiggyPluginOptions(ssr));
    },
});

function getZiggyPluginOptions(ssr: boolean) {
    if (ssr) {
        return {
            ...ziggyOptions,
            // possibility to add custom options here
        };
    }

    return ziggyOptions;
}
